/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Buttons_RedeemInputs */

const id_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukarkan Sekarang`)
};

const ms_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebus Sekarang`)
};

const da_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indløs Nu`)
};

const de_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt einlösen`)
};

const en_us2_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redeem Now`)
};

const es_es2_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canjear ahora`)
};

const es_mx2_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canjear ahora`)
};

const fil_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-redeem Ngayon`)
};

const fr_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupérer maintenant`)
};

const it_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscatta ora`)
};

const hu_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beváltás most`)
};

const nl_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu inwisselen`)
};

const no_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Løs inn nå`)
};

const pl_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odbierz teraz`)
};

const pt_br2_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resgatar agora`)
};

const pt_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resgatar agora`)
};

const ro_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redecă acum`)
};

const fi_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunasta nyt`)
};

const sv_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lös in nu`)
};

const vi_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi ngay`)
};

const tr_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Kullan`)
};

const cs_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uplatnit nyní`)
};

const bg_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вземете сега`)
};

const ru_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забрать сейчас`)
};

const uk_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримати зараз`)
};

const ar_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استلم الآن`)
};

const hi_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी प्राप्त करें`)
};

const th_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับเลย`)
};

const ja_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ受け取る`)
};

const zh_cn2_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即领取`)
};

const zh_hant1_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即領取`)
};

const ko_freebies_buttons_redeem = /** @type {(inputs: Freebies_Buttons_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 받기`)
};

/**
* | output |
* | --- |
* | "Redeem Now" |
*
* @param {Freebies_Buttons_RedeemInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_buttons_redeem = /** @type {((inputs?: Freebies_Buttons_RedeemInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Buttons_RedeemInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_buttons_redeem(inputs)
	if (locale === "ms") return ms_freebies_buttons_redeem(inputs)
	if (locale === "da") return da_freebies_buttons_redeem(inputs)
	if (locale === "de") return de_freebies_buttons_redeem(inputs)
	if (locale === "en-US") return en_us2_freebies_buttons_redeem(inputs)
	if (locale === "es-ES") return es_es2_freebies_buttons_redeem(inputs)
	if (locale === "es-MX") return es_mx2_freebies_buttons_redeem(inputs)
	if (locale === "fil") return fil_freebies_buttons_redeem(inputs)
	if (locale === "fr") return fr_freebies_buttons_redeem(inputs)
	if (locale === "it") return it_freebies_buttons_redeem(inputs)
	if (locale === "hu") return hu_freebies_buttons_redeem(inputs)
	if (locale === "nl") return nl_freebies_buttons_redeem(inputs)
	if (locale === "no") return no_freebies_buttons_redeem(inputs)
	if (locale === "pl") return pl_freebies_buttons_redeem(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_buttons_redeem(inputs)
	if (locale === "pt") return pt_freebies_buttons_redeem(inputs)
	if (locale === "ro") return ro_freebies_buttons_redeem(inputs)
	if (locale === "fi") return fi_freebies_buttons_redeem(inputs)
	if (locale === "sv") return sv_freebies_buttons_redeem(inputs)
	if (locale === "vi") return vi_freebies_buttons_redeem(inputs)
	if (locale === "tr") return tr_freebies_buttons_redeem(inputs)
	if (locale === "cs") return cs_freebies_buttons_redeem(inputs)
	if (locale === "bg") return bg_freebies_buttons_redeem(inputs)
	if (locale === "ru") return ru_freebies_buttons_redeem(inputs)
	if (locale === "uk") return uk_freebies_buttons_redeem(inputs)
	if (locale === "ar") return ar_freebies_buttons_redeem(inputs)
	if (locale === "hi") return hi_freebies_buttons_redeem(inputs)
	if (locale === "th") return th_freebies_buttons_redeem(inputs)
	if (locale === "ja") return ja_freebies_buttons_redeem(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_buttons_redeem(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_buttons_redeem(inputs)
	return ko_freebies_buttons_redeem(inputs)
});
export { freebies_buttons_redeem as "freebies.buttons.redeem" }